import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { getSidebarStatus, setSidebarStatus } from '@/utils/cookies'

// Enum to define device types
export enum DeviceType {
  Mobile,
  Desktop
}

// Pinia store definition
export const useAppStore = defineStore('app', () => {
  // State
  const sidebar = ref({
    opened: getSidebarStatus() !== 'closed',
    withoutAnimation: false
  })

  const device = ref(DeviceType.Desktop)
  const isMobileViewport = ref(false)
  const routes = ref<any>([])

  // Mutations (direct state mutations)
  const toggleSidebar = (withoutAnimation: boolean) => {
    sidebar.value.opened = !sidebar.value.opened
    sidebar.value.withoutAnimation = withoutAnimation
    setSidebarStatus(sidebar.value.opened ? 'opened' : 'closed')
  }

  const closeSidebar = (withoutAnimation: boolean) => {
    sidebar.value.opened = false
    sidebar.value.withoutAnimation = withoutAnimation
    setSidebarStatus('closed')
  }

  const openSidebar = (withoutAnimation: boolean) => {
    sidebar.value.opened = true
    sidebar.value.withoutAnimation = withoutAnimation
    setSidebarStatus('opened')
  }

  const toggleViewport = (mobile: boolean) => {
    isMobileViewport.value = mobile
  }

  // Actions
  const ToggleSideBar = (withoutAnimation: boolean) => {
    toggleSidebar(withoutAnimation)
  }

  const CloseSideBar = (withoutAnimation: boolean) => {
    closeSidebar(withoutAnimation)
  }

  const OpenSideBar = (withoutAnimation: boolean) => {
    openSidebar(withoutAnimation)
  }

  const ToggleDevice = (newDevice: DeviceType) => {
    device.value = newDevice
  }

  const SetViewport = (mobile: boolean) => {
    toggleViewport(mobile)
  }

  const SetRoutes = (newRoutes: any) => {
    routes.value = newRoutes
  }

  // Getters
  const sidebarStatus = computed(() => sidebar.value.opened)
  const sidebarWithoutAnimation = computed(() => sidebar.value.withoutAnimation)

  return {
    // State
    sidebar,
    device,
    isMobileViewport,
    routes,

    // Actions
    ToggleSideBar,
    CloseSideBar,
    OpenSideBar,
    ToggleDevice,
    SetViewport,
    SetRoutes,

    // Getters
    sidebarStatus,
    sidebarWithoutAnimation
  }
})
